import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/icons/Menu';
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowBack from '@material-ui/icons/ArrowBack';
import DashboardNavbarLinks from 'components/Navbars/DashboardNavbarLinks';
import Button from 'components/CustomButtons/Button';

import adminNavbarStyle from 'assets/jss/material-dashboard-pro-react/components/adminNavbarStyle';
import dashboardNavbarStyle from 'assets/jss/material-dashboard-pro-react/components/dashboardNavbarStyle';
import { useMediaQuery, useTheme } from '@material-ui/core';

// @ts-ignore
const useAdminNavbarStyle = makeStyles(adminNavbarStyle);
const useDashboardNavbarStyle = makeStyles(dashboardNavbarStyle);

interface IDashboardNavbar {
	color?: 'primary' | 'info' | 'success' | 'warning' | 'danger';
	rtlActive?: boolean;
	brandNode?: React.ReactElement;
	miniActive: boolean;
	handleDrawerToggle: () => void;
	sidebarMinimize: () => void;
}

export default function DashboardNavbar(props: IDashboardNavbar) {
	const adminNavbarClasses = useAdminNavbarStyle();
	const dashboardNavbarClasses = useDashboardNavbarStyle();
	const { color, rtlActive, brandNode } = props;
	const appBarClasses = classNames({
		[adminNavbarClasses[color]]: color,
		[adminNavbarClasses.appBar]: true,
	});
	const sidebarMinimize = classNames({
		[adminNavbarClasses.sidebarMinimize]: true,
		[adminNavbarClasses.sidebarMinimizeRTL]: rtlActive,
	});

	const minimizeButtonClasses = classNames({
		[dashboardNavbarClasses.minimizeButton]: true,
		[dashboardNavbarClasses.miniActive]: props.miniActive,
	});

	const theme = useTheme();
	const isSidebarMinimize = useMediaQuery(theme.breakpoints.up('md'));

	return (
		<AppBar className={appBarClasses}>
			<Toolbar className={adminNavbarClasses.container}>
				<div className={sidebarMinimize}>
					<Button
						justIcon
						round
						color="primary-dark"
						onClick={isSidebarMinimize ? props.sidebarMinimize : props.handleDrawerToggle}
						className={minimizeButtonClasses}
						id="sidebar-toggle-button"
					>
						<>
							<Menu />
							<ArrowBack className={dashboardNavbarClasses.arrowBack} />
							<ArrowForward className={dashboardNavbarClasses.arrowForward} />
						</>
					</Button>
				</div>
				<div className={adminNavbarClasses.flex}>
					<div className={dashboardNavbarClasses.brand}>{brandNode}</div>
				</div>
				<DashboardNavbarLinks rtlActive={rtlActive} />
			</Toolbar>
		</AppBar>
	);
}

DashboardNavbar.propTypes = {};
